module.exports = __webpack_public_path__ + "img/ideal_2024_10_23.0ea7bb7.svg";